import { InjectionToken } from '@angular/core';

export const HERO_DEFAULT_LANGUAGE = new InjectionToken<string>('HERO default language');
